export const FETCH_HARDWARES_REQUEST = 'HARDWARES/FETCH/REQUEST';
export const FETCH_HARDWARES_SUCCESS = 'HARDWARES/FETCH/SUCCESS';
export const FETCH_HARDWARES_FAILURE = 'HARDWARES/FETCH/FAILURE';

export const FETCH_UNASSIGNED_HARDWARES_REQUEST = 'HARDWARES/UNASSIGNED/FETCH/REQUEST';
export const FETCH_UNASSIGNED_HARDWARES_SUCCESS = 'HARDWARES/UNASSIGNED/FETCH/SUCCESS';
export const FETCH_UNASSIGNED_HARDWARES_FAILURE = 'HARDWARES/UNASSIGNED/FETCH/FAILURE';

export const DELETE_HARDWARE_REQUEST = 'HARDWARES/DELETE/REQUEST';
export const DELETE_HARDWARE_SUCCESS = 'HARDWARES/DELETE/SUCCESS';
export const DELETE_HARDWARE_FAILURE = 'HARDWARES/DELETE/FAILURE';

export const LINK_HARDWARE_REQUEST = 'HARDWARES/LINK/REQUEST';
export const LINK_HARDWARE_SUCCESS = 'HARDWARES/LINK/SUCCESS';

export const PATCH_STATUS_HARDWARE_REQUEST = 'HARDWARES/STATUS/PATCH/REQUEST';
export const PATCH_STATUS_HARDWARE_SUCCESS = 'HARDWARES/STATUS/PATCH/SUCCESS';
export const PATCH_STATUS_HARDWARE_FAILURE = 'HARDWARES/STATUS/PATCH/FAILURE';

export const RESET_HARDWARES_DASHBOARD = 'HARDWARES/DASHBOARD/RESET';

export const SET_HARDWARES_DASHBOARD_FILTER = 'HARDWARES/DASHBOARD/FILTER/SET';
export const SET_HARDWARES_DASHBOARD_FILTERS = 'HARDWARES/DASHBOARD/FILTERS/SET';
export const CLEAR_HARDWARES_DASHBOARD_FILTER = 'HARDWARES/DASHBOARD/FILTERS/CLEAR';
export const REMOVE_HARDWARES_DASHBOARD_FILTER = 'HARDWARES/DASHBOARD/FILTERS/REMOVE';

export const OPEN_CREATE_HARDWARE_MODAL = 'HARDWARES/CREATION_MODAL/OPEN';
export const HIDE_CREATE_HARDWARE_MODAL = 'HARDWARES/CREATION_MODAL/HIDE';

export const PERSISTED_ACTION_TYPES = [
  SET_HARDWARES_DASHBOARD_FILTER,
  SET_HARDWARES_DASHBOARD_FILTERS,
  CLEAR_HARDWARES_DASHBOARD_FILTER,
  REMOVE_HARDWARES_DASHBOARD_FILTER
];
